import { useMemo } from 'react'
import { useQuery } from 'urql'
import { graphql } from 'app/generated/gql'

const OUTBOUND_NUMBERS_QUERY = graphql(`
  query OutboundNumbers($id: ID!) {
    location(id: $id) {
      id
      officeMainNumber
      businessPhone
      primaryTrackingNumber
      callRailCompanyId
    }
  }
`)

type OutboundNumbers = {
  officeMainNumber: string
  primaryTrackingNumber: string
  hasCallRail: boolean
}

export function useOutboundNumbers(locationId: string | undefined): [OutboundNumbers | undefined, boolean] {
  const [result] = useQuery<{
    location: {
      id: string
      officeMainNumber?: string
      businessPhone?: string
      primaryTrackingNumber?: string
      callRailCompanyId?: string
    } | null
  }>({
    query: OUTBOUND_NUMBERS_QUERY,
    variables: { id: locationId },
    pause: !locationId,
  })

  const data = useMemo<OutboundNumbers | undefined>(() => {
    const loc = result.data?.location
    if (!loc) return undefined
    return {
      officeMainNumber: loc.officeMainNumber || loc.businessPhone || ``,
      primaryTrackingNumber: loc.primaryTrackingNumber || ``,
      hasCallRail: Boolean(loc.callRailCompanyId),
    }
  }, [result.data?.location])

  return [data, result.fetching]
}
